<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save"  @imp="imp" @del="delall"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                        <div class="btnnowrap" style="margin-top: 2px;">
                            <el-button type="primary" size="mini" @click="impPrice" :disabled="!btn.batch">{{$t('getapi[6694]')}}</el-button>
                            <el-button type="primary" size="mini" @click="setInvalid" :disabled="!btn.batchsetinvalid">{{$t('getapi[4093]')}}</el-button>
                            <el-button type="primary" size="mini" @click="batchSetValid" :disabled="!btn.batchsetvalid">{{$t('getapi[4094]')}}</el-button>
                        </div>
                 <wTable ref="singleTable"
                         :data="dataSet"
                         id="xpane-0"
                         :loading="loading"
                         :filter_language="['isFirstVenderName','isValidName','ce_flag']"
                         queryData="ISSProcessQuotationViewInfo"
                         :filter_thousandth="['Unit_Price','Net_unit_price','Shipment_Cycle','moq']"
                         :header="tableHeader"  :option="tableOption"  @handleSelectionChange="handleSelectionChange" @edits="edits" @rowdblclick="openEdit"  @lct="lct"></wTable>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" @click="SetInvalid(1)" :disabled="!btn.setEnable">{{$t('getapi[6695]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="setEnable(0)" :disabled="!btn.setInvalid">{{$t('getapi[6696]')}}
                        </el-button>
                    </div>
                    <div style="width:800px;min-width:800px">
                        <table>
                            <tr>
                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[6697]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" v-model="dataDetail.num" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[410]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" v-model="dataDetail.CreatePerson"  :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[135]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" v-model="dataDetail.CreateDate" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[115]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" v-model="dataDetail.FIELD" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td><span>{{$t('getapi[1287]')}}</span></td>
                                <td>
                                    <routejump :urlNo="26">
                                    <el-input
                                        :disabled="dataDetail.num!=''?true:false"
                                        v-model="dataDetail.Vender_Code"
                                        type="text"
                                        readonly
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectsupplier"></i>
                                </el-input>
                                    </routejump></td>
                                <td><span>{{$t('getapi[1197]')}}</span></td>
                                <td><el-input type="text" size="mini" v-model="dataDetail.Vender_Name" :readonly="true" class="readO"></el-input></td>
                                <td><span>{{$t('getapi[552]')}}</span></td>
                                <td>
                                    <el-input v-if="dataDetail.isValid=='False'" type="text" size="mini" :value="$t('getapi[1171]')" :readonly="true" class="readO"></el-input>
                                    <el-input v-if="dataDetail.isValid!='False'" type="text" size="mini" :value="$t('getapi[1170]')" :readonly="true" class="readO"></el-input>
                                </td>
                                <td colspan="2"><span>{{ $t('getapi[1308]') }}</span>
                                    <el-checkbox size="mini" v-model="dataDetail.check_flag" style="margin-left: 5px;" :true-label="1" :false-label="0" :disabled="dataDetail.isValid!='False'"></el-checkbox></td>
                            </tr>
                            <tr>
                                <td><span>{{$t('getapi[112]')}}</span></td>
                                <td>
                                    <routejump :urlNo="12">
                                    <el-input
                                        :disabled="dataDetail.num!=''?true:false"
                                        v-model="dataDetail.Part_Code"
                                        type="text"
                                        readonly
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectpart"></i>

                                </el-input>
                                    </routejump></td>
                                <td><span>{{$t('getapi[116]')}}</span></td>
                                <td><el-input type="text" size="mini" v-model="dataDetail.Part_Name" :readonly="true" class="readO"></el-input></td>
                                <td colspan="2">
                                    <span>{{ $t('getapi[8047]') }}</span>
                                    <el-checkbox size="mini" v-model="dataDetail.ce_flag" style="margin-left: 5px;" :true-label="1" :false-label="0" :disabled="true"></el-checkbox>
                                </td>
                                <td><span style="width:90px">{{$t('getapi[1301]')}}</span></td>
                                <td>
                                    <el-input  type="text" size="mini"  v-model="dataDetail.vender_Part_Code" :readonly="dataDetail.isValid!='False'" :class="{'readO':dataDetail.isValid!='False'}"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <!--<div class="box" style="margin-top:5px">
                        <div class="bbl">
                            <span>{{$t('getapi[6697]')}}</span>
                            <el-input type="text" size="mini" style="width: 130px;"  v-model="dataDetail.num" :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[410]')}}</span>
                            <el-input type="text" size="mini" style="width: 130px;" v-model="dataDetail.CreatePerson"  :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[135]')}}</span>
                            <el-input type="text" size="mini" style="width: 130px;" v-model="dataDetail.CreateDate" :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[115]')}}</span>
                            <el-input type="text" size="mini" style="width: 130px;" v-model="dataDetail.FIELD" :readonly="true" class="readO"></el-input>
                        </div>
                        <div class="bbl">
                            <span>{{$t('getapi[1287]')}}</span>
                            <el-input
                                    :disabled="dataDetail.num!=''?true:false"
                                    v-model="dataDetail.Vender_Code"
                                    type="text"
                                    readonly
                                    size="mini"
                                    style="width: 130px;"
                            >
                                <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectsupplier"></i>

                            </el-input>
                                &lt;!&ndash;<el-input type="text" size="mini" style="width: 130px;" @dblclick.native="selectsupplier" v-model="dataDetail.Vender_Code" :disabled="dataDetail.num!=''?true:false"></el-input>&ndash;&gt;
                            <span>{{$t('getapi[1197]')}}</span>
                                <el-input type="text" size="mini" style="width: 130px;" v-model="dataDetail.Vender_Name" :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[552]')}}</span>
                                <el-input v-if="dataDetail.isValid=='False'" type="text" size="mini" style="width: 130px;" :value="$t('getapi[1171]')" :readonly="true" class="readO"></el-input>
                                <el-input v-if="dataDetail.isValid!='False'" type="text" size="mini" style="width: 130px;" :value="$t('getapi[1170]')" :readonly="true" class="readO"></el-input>

                            <span>{{ $t('getapi[1308]') }}</span>
                            <el-checkbox size="mini" v-model="dataDetail.check_flag" style="margin-left: 0px;width: 130px;" :true-label="1" :false-label="0" :disabled="dataDetail.isValid!='False'"></el-checkbox>

                        </div>
                        <div class="bbl">
                        <span>{{$t('getapi[112]')}}</span>
                            <el-input
                                    :disabled="dataDetail.num!=''?true:false"
                                    v-model="dataDetail.Part_Code"
                                    type="text"
                                    readonly
                                    size="mini"
                                    style="width: 130px;"
                            >
                                <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectpart"></i>

                            </el-input>
                        &lt;!&ndash;<el-input type="text" size="mini" style="width: 130px;"  @dblclick.native="selectpart"  v-model="dataDetail.Part_Code" :disabled="dataDetail.num!=''?true:false"></el-input>&ndash;&gt;
                        <span>{{$t('getapi[116]')}}</span>
                        <el-input type="text" size="mini" style="width: 130px;"  v-model="dataDetail.Part_Name" :readonly="true" class="readO"></el-input>
                        
                        <span>{{ $t('getapi[8047]') }}</span>
                        <el-checkbox size="mini" v-model="dataDetail.ce_flag" style="margin-left: 0px;width: 130px;" :true-label="1" :false-label="0" :disabled="true"></el-checkbox>

                        <span style="width:90px">{{$t('getapi[1301]')}}</span>
                        <el-input  type="text" size="mini" style="width: 130px;"  v-model="dataDetail.vender_Part_Code" :readonly="dataDetail.isValid!='False'" :class="{'readO':dataDetail.isValid!='False'}"></el-input>
                        </div>
                    </div>-->
                    <el-tabs :tab-position="'top'"  >
                        <el-tab-pane :label="$t('getapi[6698]')" name="0">
                            <div style="width:800px;min-width:800px">
                                <table>
                                    <tr>
                                        <td style="width:80px;min-width:80px"><span>{{$t('getapi[6699]')}}</span></td>
                                        <td style="width:120px;min-width:120px">
                                            <routejump :urlNo="13">
                                            <el-input
                                                    :disabled="dataDetail.isValid == 'True'"
                                                    v-model="dataDetail.Routing_Start_Name"
                                                    type="text"
                                                    readonly
                                                    size="mini"
                                            >
                                                <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectRouting"></i>
                                            </el-input>
                                            </routejump>
                                        </td>
                                        <td style="width:80px;min-width:80px"><span>{{$t('getapi[573]')}}</span></td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.RoutingSequenceNo"  :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td style="width:80px;min-width:80px"><span>{{$t('getapi[547]')}}</span></td>
                                        <td style="width:120px;min-width:120px"><el-input v-model="dataDetail.RoutingVersion" :readonly="true" class="readO"></el-input></td>
                                        <td style="width:80px;min-width:80px"><span>{{$t('getapi[1409]')}}</span></td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 100px;" v-model="dataDetail.Shipment_Cycle" :readonly="dataDetail.isValid!='False'" :class="[dataDetail.isValid!='False'?'readO':'mcolor']"></el-input>{{$t('getapi[217]')}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span>{{$t('getapi[3958]')}}</span></td>
                                        <td>
                                            <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :value="dataDetail.Unit_Price"  :readonly="!dataDetail.Tax_flag || dataDetail.isValid!='False'" :class="{'readO':!dataDetail.Tax_flag || dataDetail.isValid!='False'}" @input="CalTaxPrice1"></el-input>
                                        </td>
                                        <td><span>{{$t('getapi[1225]')}}</span></td>
                                        <td>
                                            <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 110px;" :value="dataDetail.Tax_Rate | cutZero"  :readonly="true" class="readO"></el-input>%
                                        </td>
                                        <td><span>{{$t('getapi[1227]')}}</span></td>
                                        <td><el-input size="mini" v-model="dataDetail.Currency_Code" :readonly="true" class="readO"></el-input></td>
                                        <td colspan="2">
                                            <span>{{$t('getapi[1421]')}}</span>
                                            <el-checkbox :disabled="true" v-model="dataDetail.Tax_flag" style="margin-left: 5px"></el-checkbox>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span>{{$t('getapi[3711]')}}</span></td>
                                        <td>
                                            <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Net_unit_price"  :readonly="dataDetail.Tax_flag || dataDetail.isValid!='False'" :class="{'readO':dataDetail.Tax_flag || dataDetail.isValid!='False'}" @input="CalTaxPrice"></el-input>
                                        </td>
                                        <td><span>{{$t('getapi[888]')}}</span></td>
                                        <td>
                                            <el-input type="text" size="mini" v-model="dataDetail.InvUnit"  :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td><span>{{$t('getapi[6701]')}}</span></td>
                                        <td>
                                            <el-date-picker
                                                    v-model="dataDetail.PriceEffective_Date"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    style="width: 100%;"
                                                    size="mini"
                                            ></el-date-picker>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span>{{$t('getapi[219]')}}</span></td>
                                        <td>
                                            <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Moq" :readonly="dataDetail.isValid!='False'" :class="[dataDetail.isValid!='False'?'readO':'mcolor']"></el-input>
                                        </td>
                                        <td colspan="2">
                                            <span>{{$t('getapi[1309]')}}</span>
                                            <el-checkbox true-label='True' false-label="False" style="margin-left: 5px" v-model="dataDetail.isFirstVender"  :checked="dataDetail.isFirstVender=='True'?true:false" :readonly="true" class="readO"></el-checkbox>
                                        </td>
                                        <td><span>{{$t('getapi[164]')}}</span></td>
                                        <td>
                                            <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.order_addqty" :readonly="dataDetail.isValid!='False'" :class="[dataDetail.isValid!='False'?'readO':'mcolor']"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span>{{$t('getapi[6702]')}}</span></td>
                                        <td colspan="7">
                                            <el-input type="textarea" v-model="dataDetail.Process_Remark"  size="mini" :readonly="dataDetail.isValid!='False'" :class="{'readO':dataDetail.isValid!='False'}"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span>{{$t('getapi[6703]')}}</span></td>
                                        <td colspan="3">
                                            <el-input type="textarea" v-model="dataDetail.Packaging_Style" size="mini" :readonly="dataDetail.isValid!='False'" :class="{'readO':dataDetail.isValid!='False'}"></el-input>
                                        </td>
                                        <td><span>{{$t('getapi[143]')}}</span></td>
                                        <td colspan="3">
                                            <el-input type="textarea" v-model="dataDetail.Remarks" size="mini" :readonly="dataDetail.isValid!='False'" :class="{'readO':dataDetail.isValid!='False'}"></el-input>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <!--<div class="box" style="height: 300px;margin-top:5px">
                            <div class="bbl">
                                <span>{{$t('getapi[6699]')}}</span>
                                <el-input
                                        :disabled="dataDetail.isValid == 'True'"
                                        v-model="dataDetail.Routing_Start_Name"
                                        type="text"
                                        readonly
                                        size="mini"
                                        style="width: 130px;"
                                >
                                    <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectRouting"></i>

                                </el-input>
                                &lt;!&ndash;<el-input type="text" size="mini" style="width: 130px;" @dblclick.native="selectRouting" v-model="dataDetail.Routing_Start_Name" :disabled="dataDetail.isValid == 'True'"></el-input>&ndash;&gt;
                                <span>{{$t('getapi[573]')}}</span>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;" v-model="dataDetail.RoutingSequenceNo"  :readonly="true" class="readO"></el-input>
                                <span>{{$t('getapi[547]')}}</span>
                                <el-input style="width: 130px;" v-model="dataDetail.RoutingVersion" :readonly="true" class="readO"></el-input>
                                <span>{{$t('getapi[1409]')}}</span>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;" v-model="dataDetail.Shipment_Cycle" :readonly="dataDetail.isValid!='False'" :class="[dataDetail.isValid!='False'?'readO':'mcolor']"></el-input>{{$t('getapi[217]')}}
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[3958]')}}</span>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;" :value="dataDetail.Unit_Price"  :readonly="!dataDetail.Tax_flag || dataDetail.isValid!='False'" :class="{'readO':!dataDetail.Tax_flag || dataDetail.isValid!='False'}" @input="CalTaxPrice1"></el-input>
                                <span>{{$t('getapi[1225]')}}</span>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;" :value="dataDetail.Tax_Rate | cutZero"  :readonly="true" class="readO"></el-input>%
                                <span>{{$t('getapi[1227]')}}</span>
                                <el-input size="mini" style="width: 130px;" v-model="dataDetail.Currency_Code" :readonly="true" class="readO"></el-input>
                                <span>{{$t('getapi[1421]')}}</span>
                                <el-checkbox :disabled="true" v-model="dataDetail.Tax_flag"></el-checkbox>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[3711]')}}</span>
                                <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;" v-model="dataDetail.Net_unit_price"  :readonly="dataDetail.Tax_flag || dataDetail.isValid!='False'" :class="{'readO':dataDetail.Tax_flag || dataDetail.isValid!='False'}" @input="CalTaxPrice"></el-input>
                                <span>{{$t('getapi[888]')}}</span>
                                <el-input type="text" size="mini" style="width: 130px;" v-model="dataDetail.InvUnit"  :readonly="true" class="readO"></el-input>
                                <span>{{$t('getapi[6701]')}}</span>
                                <el-date-picker
                                v-model="dataDetail.PriceEffective_Date"
                                type="date"
                                value-format="yyyy-MM-dd"
                                style="width: 130px;"
                                size="mini"
                                ></el-date-picker>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[219]')}}</span>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;" v-model="dataDetail.Moq" :readonly="dataDetail.isValid!='False'" :class="[dataDetail.isValid!='False'?'readO':'mcolor']"></el-input>
                                <el-checkbox true-label='True' false-label="False" v-model="dataDetail.isFirstVender"  :checked="dataDetail.isFirstVender=='True'?true:false" :readonly="true" class="readO"></el-checkbox>
                                <label>{{$t('getapi[1309]')}}</label>
                                <span>{{$t('getapi[164]')}}</span>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;" v-model="dataDetail.order_addqty" :readonly="dataDetail.isValid!='False'" :class="[dataDetail.isValid!='False'?'readO':'mcolor']"></el-input>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[6702]')}}</span>
                                <el-input type="textarea" v-model="dataDetail.Process_Remark"   style="width:750px;" size="mini" :readonly="dataDetail.isValid!='False'" :class="{'readO':dataDetail.isValid!='False'}"></el-input>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[6703]')}}</span>
                                <el-input type="textarea" v-model="dataDetail.Packaging_Style"   style="width:335px;" size="mini" :readonly="dataDetail.isValid!='False'" :class="{'readO':dataDetail.isValid!='False'}"></el-input>
                                <span>{{$t('getapi[143]')}}</span>
                                <el-input type="textarea" v-model="dataDetail.Remarks"   style="width:335px;" size="mini" :readonly="dataDetail.isValid!='False'" :class="{'readO':dataDetail.isValid!='False'}"></el-input>
                            </div>
                            </div>-->
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[6704]')" name="1">
                            <el-button type="primary"  size="mini" icon="el-icon-circle-plus"  @click="selectpartt" :disabled="dataDetail.isValid!='False'">{{$t('getapi[6467]')}}</el-button>
                            <el-button type="primary"  size="mini" icon="el-icon-delete-solid" @click="delline" :disabled="dataDetail.isValid!='False'">{{$t('getapi[40]')}}</el-button>
                            <el-table
                                    id="xdetilpane-0"
                                    :data="dataDetail.Lists"
                                    ref="singleTable1"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    size="mini"
                                    :row-class-name="tableRowClassName"
                                    @selection-change="handleSelectionChangeM"
                                    :height="tableHeight - 180"
                                    header-row-class-name="headerclass"
                                    style="width: 100%; margin-top:2px"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="ListPart_MTL_CODE" :label="$t('getapi[112]')" width="150"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="ListPart_MTL_NAME" :label="$t('getapi[116]')" width="150"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="ListPart_MTL_CUR_EDITION" :label="$t('getapi[149]')" width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="ListPart_RoutingName" :label="$t('getapi[6705]')" width="100"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="ListPart_Cost" :label="$t('getapi[6706]')" width="100" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="ListPart_Qty" :label="$t('getapi[6707]')" width="100" align="right">
                                    <!-- <template slot-scope="scope">
                                    <el-input type="number" autocomplete="off" title="" v-model="scope.row.ListPart_Qty"></el-input>
                                    </template> -->
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="ListPart_MTL_MASTER_UNIT" :label="$t('getapi[888]')" width="100"></el-table-column>

                            </el-table>

                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[1298]')">
                            <div>
                                <el-button type="primary" size="mini" @click="addBatchPrice"
                                           v-if="dataDetail.isValid != 'True'">{{$t('getapi[6708]')}}
                                </el-button>
                                <el-button type="primary" size="mini" @click="batchDelPrice" v-if="dataDetail.isValid != 'True'">{{
                                    $t('getapi[4097]') }}
                                </el-button>
                            </div>
                            <el-table :data="dataDetail.BatchLists" :highlight-current-row="true"
                                      show-overflow-tooltip="true" @selection-change="handleSelectionChangePrice" border stripe
                                      size="mini" style="width: 100%;margin-top: 2px">
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column prop="batch_floor_limit" :label="$t('getapi[1351]')"
                                                 width="100" align="right">
                                    <template scope="scope" v-if="dataDetail.isValid != 'True'">
                                        <el-input size="mini" v-model="scope.row.batch_floor_limit" onchange="if(value<=0)value=''" type="number"  autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="price" :label="$t('getapi[1292]')" width="100"
                                                 align="right">
                                    <template scope="scope" v-if="dataDetail.Tax_flag == true && dataDetail.isValid != 'True'">
                                        <el-input size="mini" v-model="scope.row.price" type="number"  autocomplete="off" title="" @mousewheel.native.prevent
                                                  @change="getBatchNetPrice(scope)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="net_price" :label="$t('getapi[1352]')"
                                                 width="100" align="right">
                                    <template scope="scope" v-if="dataDetail.Tax_flag == false && dataDetail.isValid != 'True'">
                                        <el-input size="mini" v-model="scope.row.net_price" type="number"  autocomplete="off" title="" @mousewheel.native.prevent
                                                  @change="getBatchNetUnitPrice(scope)"></el-input>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>

        <serce :isVisible="isVisible" queryData="ISSProcessQuotationViewInfo" ref="ser" @getser="serclick"></serce>
        <!--选择供应商编码-->
        <selector :isVisible="false" :selectType="1" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetSupplyPopuDataList'" @callback="getsupplier" ref="supplier"></selector>
        <!--选择物料编码-->
        <selector :isVisible="false" :selectType="11" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpart" ref="part"></selector>
        <!--委外选择物料编码-->
        <selector :isVisible="false" :selectType="12" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpartt" ref="partt"></selector>
        <!--选择外协工序-->
        <selector :isVisible="false" :selectType="1" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetRoutingDataList'" @callback="getRounting" ref="Rounting"></selector>

        <ctable :isVisible="false" :title="$t('getapi[6709]')" queryData="ISSProcessQuotationViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>

    </div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
import { Loading } from 'element-ui';
    export default {
        name: 'wxprice',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                visReplacePart:false,
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('wxprice'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: 100, // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: 100, // 当前页数据量
                total2: 0, // 数据总量
                dataSet3: [], // 主表数据
                pageIndex3: 1, // 当前页
                pageSize3: 100, // 当前页数据量
                total3: 0, // 数据总量
                dataSet4: [], // 主表数据
                pageIndex4: 1, // 当前页
                pageSize4: 100, // 当前页数据量
                total4: 0, // 数据总量
                loading: false, // 主表加载状态
                IsEditPrice:false,//是否可以编辑不含税单价
                RStartName:'',//前端缓存外协工序名
                dataDetail:{
                },
                oldDataDetail:'',
                SignList: [],
                multipleSelection: [],//左侧主表选择
                multipleSelectionMain: [],
                selectData1: [],
                selectData2: [],
                selectData3: [],
                selectData4: [],
                selectDataPrice: [],
                btn:{
                    setEnable:false,
                    setInvalid:false,
                    batch: false,
                    batchsetinvalid: false,
                    batchsetvalid: false,
                },
                srType: [],//sr类别
                orderDetail: {
                    plancode: '',
                    issrso: '0',
                    isnewflag: '0',
                    sotype: '0',
                    flag: 1,
                    issselfbadflag: '0',
                    iscontinue: 0,
                },
                visOrder: false,
                orderType: 1,
                tableHeader: [],
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                code: '',
                scrollTop:0,
                scrollTop1:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            dataDetail: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(0)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('wxprice', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            //that.authority(1);
            that.confirmAdd();
            that.colsort();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('ISSProcessQuotationViewInfo',0,PFileds=>{
                that.tableHeader=PFileds;		
            });	
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1033]"),this.$t("getapi[13]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                if(!this.$limits.menuvisible("plv2", 129, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 128, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                    if(that.$limits.authority('plv2', 119, 1) > 0){
                        that.$refs.SetBtn.SetOneBtnEnable('import', true)
                    }
                } else {
                    if (that.$limits.authority('plv2', 129, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 129, 1) == 2) {
                        if (that.$limits.authority('plv3', 129,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 129,1) == 1) {
                            //编辑级
                            if(that.$limits.authority('plv2', 119, 1) > 0){
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 129, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.num)) {
                                if(that.dataDetail.isValid=='False'){
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export,del');
                                }else{
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export');
                            }
                            if(that.$limits.authority('plv2', 119, 1) > 0){
                                that.$refs.SetBtn.SetOneBtnEnable('import', true)
                            } else {
                                that.$refs.SetBtn.SetOneBtnEnable('import', false)
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;


                if(that.dataDetail.isValid != 'False'){
                    that.btn.setEnable  = false;
                    if(that.$limits.authority('plv4', 70, 1) != 0){
                        that.btn.setInvalid = true;
                    } else {
                        that.btn.setInvalid = false;
                    }
                }else{
                    if(that.$limits.authority('plv4', 69, 1) != 0){
                        that.btn.setEnable  = true
                    } else {
                        that.btn.setEnable  = false
                    }
                    that.btn.setInvalid = false;
                }

                if(that.multipleSelection.length==0){
                    that.btn.batch = false;
                    that.btn.batchsetinvalid = false;
                    that.btn.batchsetvalid = false
                }else{
                    if(that.$limits.authority('plv4', 70, 1) != 0){
                        that.btn.batch = true;
                        that.btn.batchsetinvalid = that.multipleSelection.every(val => {
                            return val.isValid == true
                        });
                        that.btn.batchsetvalid = that.multipleSelection.every(val => {
                            return val.isValid == false
                        });
                    } else {
                        that.btn.batch = false;
                        that.btn.batchsetinvalid = false;
                        that.btn.batchsetvalid = false
                    }
                }

            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
             //查看图纸
             lct(val) {
                let that = this
                let item = {
                    //技术文档
                    label:  this.$t('getapi[6575]'),
                    name: 'docmanageview',
                    path: '/docmanageview',
                    url: '/docmanageview',
                    icon: 'video-play'
                };
                that.$store.commit('setSharedParams', {
                    part_code: val.row.part_CODE
                });
                this.$router.push({ path: '/docmanageview'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('wxprice',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            impPrice(){
                let that = this;
                if(that.multipleSelection.length>1){
                     that.$message.warning(that.$t('getapi[8756]'));//请选择一条数据导入
                    return;
                }
                let parm={
                    isValidName: that.multipleSelection[0].isValidName,
                    Part_ID: that.multipleSelection[0].Part_ID,
                    Net_unit_price: that.multipleSelection[0].Net_unit_price,
                    Currency_Code: that.multipleSelection[0].Currency_Code,
                    Routing_Start_ID: that.multipleSelection[0].Routing_Start_ID
                }
                that.$http.urlpost('/ISS/PQ/CopyToStdCost', parm, function (res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                that.getView();
                }
                });
            },
            //批量设为无效
            setInvalid(){
                let that = this;
                let parm={
                    Code:'',
                };
                for(let i=0;i<that.multipleSelection.length;i++){
                    parm.Code+=that.multipleSelection[i].num+',';
                }
                parm.Code =  parm.Code.substring(0, parm.Code.length - 1);
                that.$http.urlpost('/ISS/PQ/UnISSPQ', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                        console.log("唯一号:"+that.dataDetail.num);
                        if(!that.$limits.fnIsEmpty(that.dataDetail.num)){
                            that.getDetail(that.dataDetail.num);//刷右边
                        }
                        that.getView();
                        
                    }
                });
            },
             //批量设为有效
            batchSetValid(){
                let that=this;
                let isnotice=0;
                for(let i = 0;i<that.multipleSelection.length;i++){
                    if(that.multipleSelection[i].ce_flag=='是'){
                        isnotice=1;
                    }
                }
                if(isnotice==1){
                    that.$confirm(that.$t('getapi[8048]'), that.$t('getapi[194]'), {//"CE物料已确认供应商"
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.setValid();
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                }
                else{
                    that.setValid();
                }
            },
            // 外协价表批量设为有效时税率是否变更
            setValid(){
                let that = this
                let arr = []
                for(let i=0;i<that.multipleSelection.length;i++){
                    arr = [...arr,{
                        exclusively_id: that.multipleSelection[i].num
                    }]
                }
                let parm = {
                    ls: arr
                }
                that.$http.urlpost('/ISS/PQ/ISSPQTax', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent == 1){
                            that.confirmSetValid(1, arr)
                        } else if(res.DataContent == 2){
                            that.confirmSetValid(0, arr)
                        }
                    }
                });
            },
            confirmSetValid(flg, ls){
                let that = this
                let parm = {
                    Flg: flg,
                    ls: ls
                }
                that.$http.urlpost('/ISS/PQ/ISSPQAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if(!that.$limits.fnIsEmpty(that.dataDetail.num)){
                            that.getDetail(that.dataDetail.num);//刷右边
                        }
                        that.getView();
                    }
                });
            },
             //置为无效
            SetInvalid(val){
                let that=this;
                if(that.dataDetail.ce_flag==1){
                    that.$confirm(that.$t('getapi[8048]'), that.$t('getapi[194]'), {//"CE物料已确认供应商"
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.setEnable(val);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                }
                else{
                    that.setEnable(val);
                }
            },
            setEnable(e) {
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.num)||that.$limits.fnIsEmpty(that.dataDetail.Part_ID)){
                    return;
                }
                let parm = {
                    PUBIPQID: that.dataDetail.num,
                    PUBPart_ID: that.dataDetail.Part_ID,
                    RoutingSequenceNo:that.dataDetail.RoutingSequenceNo,
                    Tax_Rate: that.dataDetail.Tax_Rate,
                    Tax_Rate_Confrm: 0,//
                    Type: "1"
                    }
                //1 置有效
                if(e==0){
                    parm.Type="0";
                }
                that.$http.urlpost('/ISS/PQ/SetStatus', parm, function (res) {
                if(res.Success == 1){
                that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                that.getView();
                that.getDetail(that.dataDetail.num);//刷右边
                }else if (res.Success == 2) {
                //that.$message.success(res.Msg);
                //弹框
                //确认
                const newDatas = []
                const h = that.$createElement;
                newDatas.push(h('p', null, that.$processdata.explainCallbackMsg(res.Msg)));
                parm.Tax_Rate_Confrm=1;

                that.$confirm(
                h('div', null, newDatas), that.$t('getapi[241]'), {
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning',
                })
                .then(() => {
                that.$http.urlpost('/ISS/PQ/SetStatus', parm, function(res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                that.getView();
                that.getDetail(that.dataDetail.num);//刷右边

                }
                });

                })
                .catch(() => {
                this.$message({
                type: 'info',
                message: that.$t('getapi[6096]')
                });
                });

                //取消
                }
                });

                //0 置无效
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ISSProcessQuotationViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },

            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/ISS/PQ/ISSPQList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                    //that.authority(1);
                });
            },
            // 根据ID获取详情数据
            edits(row) {
                let that = this
                if(that.code == row.num){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 129, 1)){
                        return
                    }
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index'];
                    }
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.code = row.num
                                that.oldrow = row
                                that.getDetail(row.num);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.code = row.num
                        that.oldrow = row
                        that.getDetail(row.num);
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                delete datacopy.Lists[i]['index'];
                }
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 0
                that.code = ''
                let date = Common.methods.getDate()
                that.dataDetail = {
                    Lists: [],
                    BatchLists:[],
                    num:"",
                    Vender_Code: "",
                    Vender_Name: "",
                    Part_ID: "",
                    Part_Code: "",
                    Part_Name: "",
                    FIELD: "1",
                    vender_Part_Code: "",
                    Routing_Start_ID: "",
                    Routing_Start_Name: "",
                    Routing_End_ID: "",
                    Routing_End_Name: "",
                    Unit_Price: "0",
                    Net_unit_price: "0",
                    Tax_Rate: "",
                    Currency_Code: "",
                    InvUnit: "",
                    Process_Remark: "",
                    Shipment_Cycle: "",
                    Packaging_Style: "",
                    isFirstVender: false,
                    PriceEffective_Date: "",
                    isValid: "False",
                    ReviewMan: "",
                    ReviewDate: "",
                    Remarks: "",
                    CreatePerson: "",
                    CreateDate: "",
                    UpdatePerson: "",
                    UpdateDate: "",
                    isDelete: "",
                    isSealed: "",
                    RoutingSequenceNo: "",
                    RoutingVersion: "",
                    RoutingRelationNo: "",
                    OldRoutingID: "",
                    OldUnitPrice: "0",
                    Tax_flag: false,
                    Moq: "",
                    check_flag:1,
                }
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();
                if(!that.$limits.fnIsEmpty(that.dataDetail.num)){
                    that.getDetail(that.dataDetail.num);
                }*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                delete datacopy.Lists[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if(!that.$limits.fnIsEmpty(that.dataDetail.num)){
                                that.getDetail(that.dataDetail.num);
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    that.getView();
                    if(!that.$limits.fnIsEmpty(that.dataDetail.num)){
                        that.getDetail(that.dataDetail.num);
                    } else {
                        that.confirmAdd()
                    }
                }
            },
            selectRouting(){
                let that = this;
                if (that.$limits.fnIsEmpty(that.dataDetail.Part_Code)) {
                    that.$message.warning(this.$t('getapi[8793]'));//'请先选择物料'
                    return;
                }
                let param = {
                part_code: that.dataDetail.Part_Code,
                part_version: that.dataDetail.Part_Name,
                PUBPart_ID: that.dataDetail.Part_ID
                }
                that.$refs.Rounting.clearInput(true,param);
            },
            //工序信息填写
            getRounting(data){
                let that = this;
                console.log(data)
                //如果序号变更 OldRoutingID
                if(that.dataDetail.RoutingSequenceNo != data.routing_sequence){
                    that.dataDetail.OldRoutingID = that.dataDetail.RoutingSequenceNo;
                }else{
                    that.dataDetail.OldRoutingID=null;
                }
                //that.dataDetail.OldRoutingID = that.dataDetail.RoutingSequenceNo;
                that.dataDetail.RoutingSequenceNo = data.routing_sequence;
                that.dataDetail.RoutingVersion = data.routing_version;
                that.dataDetail.Routing_Start_Name = data.workproc_name;
                //that.dataDetail.Routing_Start_ID = that.dataDetail.RoutingStartName;
                that.dataDetail.Routing_Start_ID = data.routing_sequence;
                that.dataDetail.RoutingRelationNo = data.routing_relation_no;
                that.dataDetail.Process_Remark = data.workproc_description;
            },
            //委外选择物料后加入到明细
            getpartt(data){
                let that = this;
                let obj = {
                        num: 0,
                        Quotation_num: that.dataDetail.num,
                        Part_ID: that.dataDetail.Part_ID,
                        ListPart_ID: data.exclusively_id,
                        ListPart_routing_ID: 0,
                        ListPart_Cost: data.Column1,
                        ListPart_Qty: data.mount,
                        ListPart_MTL_CODE: data.part_code,
                        ListPart_MTL_NAME: data.part_name,
                        ListPart_MTL_CUR_EDITION: data.part_version,
                        ListPart_RoutingName: "",
                        ListPart_MTL_MASTER_UNIT: data.part_master_unit
                    }
                that.dataDetail.Lists.push(obj);
            },
            selectsupplier(){
                let that = this;
                if(!that.$limits.fnIsEmpty(that.dataDetail.num))return;
                that.$refs.supplier.clearInput(true);
            },
            getsupplier(data){
                let that = this;
                that.dataDetail.Vender_Code = data.vender_code;
                that.dataDetail.Vender_Name = data.vender_name;
                that.dataDetail.Tax_flag = data.tax_flag;
                that.dataDetail.Currency_Code = data.currency_code;
                if(that.$limits.fnIsEmpty(data.vender_code)){
                    that.IsEditPrice = false;
                }else{
                    if(that.dataDetail.Tax_Rate != data.tax_rate){//税率有变化，重新计算
					//不含税价-->含税价
                    that.dataDetail.Tax_Rate = data.tax_rate;
                    let price = that.dataDetail.Net_unit_price * (1 + that.dataDetail.Tax_Rate/100);
                    that.dataDetail.OldUnitPrice = that.dataDetail.Unit_Price;
					that.dataDetail.Unit_Price = price.toFixed(2);
                    }else{
                        that.dataDetail.OldUnitPrice=0;
                    }
                }
                that.IsEditPrice = true;

            },
            CalTaxPrice(e){
                let that =this;
                that.dataDetail.Net_unit_price = e;
                that.dataDetail.OldUnitPrice = parseFloat(that.dataDetail.Unit_Price);
                let price = e * (1 + that.dataDetail.Tax_Rate/100);
                that.dataDetail.Unit_Price = parseFloat(price.toFixed(5));

            },
            CalTaxPrice1(e){
                let that =this;
                that.dataDetail.Unit_Price = e;
                let price = e / (1 + that.dataDetail.Tax_Rate/100);
                that.dataDetail.Net_unit_price = parseFloat(price.toFixed(5));

            },
            // 批量选择
            handleSelectionChange(val) {
            let that = this;
            that.multipleSelection = val;
            that.btnauthority();
            },
            // 批量选择
            handleSelectionChangeM(val) {
            //let that = this;
            this.multipleSelectionMain = val;
            },
            tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
            },
            delline() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        if(that.multipleSelectionMain.length==0)return;
                        let param = {
                            ids: "",
                        }
                        for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                            that.dataDetail.Lists.splice(that.multipleSelectionMain[i].index, 1);
                            if(that.multipleSelectionMain[i].num != ''){
                                param.ids = param.ids+that.multipleSelectionMain[i].num+',';
                            }
                        }
                        if(param.ids!=''){
                            param.ids = param.ids.substring(0,param.ids.length-1);
                            that.$http.urlpost('/ISS/PQ/DeleteISSPartListByID', param, function (res) {
                                //that.btn.deleteline = true;
                                if (res.Success == 1) {
                                    if(!that.$limits.fnIsEmpty(that.dataDetail.num)){
                                        that.getDetail(that.dataDetail.num);//刷右边
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //导入
            imp() {
            let item = {
            //label: '外协价表导入',
            label: '通用导入',
            name: 'exp',
            path: '/exp/13',
            url: '/exp/13',
            icon: 'video-play'
            };
            this.$router.push({ path: '/exp/13' });
            this.$store.commit('selectMenu', item);
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true;
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/PQ/ISSPQExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    that.loading = false;
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ISSProcessQuotationViewInfo",
                    fromname: that.$t('getapi[1033]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail;
                if(that.$limits.fnIsEmpty(parm.Shipment_Cycle)){
                    that.$message.warning(that.$t('getapi[1370]'));//'交货周期必填！'
                    return;
                }
                if(that.$limits.fnIsEmpty(parm.Moq)){
                    that.$message.warning(that.$t('getapi[8841]'));//'最小批量必填！'
                    return;
                }
                for(let i = 0;i<that.dataDetail.BatchLists.length;i++){
                    if(that.dataDetail.BatchLists[i].batch_floor_limit <= 0){
                        that.$message.warning(that.$t('getapi[8842]'))//'批量下限不能小于0！'
                        return
                    }
                }
                if(parm.isValid==true||parm.isValid=="True"){
                    parm.isValid = "1";
                }else parm.isValid = "0";
                if(parm.isFirstVender==true||parm.isFirstVender=="True"){
                    parm.isFirstVender = "1";
                }else parm.isFirstVender = "0";

                if(that.$limits.fnIsEmpty(parm.OldRoutingID)){
                    parm.OldRoutingID = parm.Routing_Start_ID;
                }
                //新增与修改
                 if(that.$limits.fnIsEmpty(parm.num)){
                     //新增
                    parm.OldUnitPrice = parm.Unit_Price;
                }
                //无理由加
                parm.Routing_End_Name = parm.Routing_Start_Name;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/ISS/PQ/SaveISSPQ', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[3153]'));//'保存成功'
                        that.getDetail(res.UniqueNum);
                    } else {
                        if(parm.isValid==1||parm.isValid=="1"){
                            parm.isValid = "True";
                        }else parm.isValid = "False";
                        if(parm.isFirstVender==1||parm.isFirstVender=="1"){
                            parm.isFirstVender = "True";
                        }else parm.isFirstVender = "False";
                    }
                });
            },
            //删单
            delall(){
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.num))return;
                let param = {
                ids: that.dataDetail.num,
                }
                that.$refs.SetBtn.SetOneBtnEnable('del',false);
                that.$http.urlpost('/ISS/PQ/DelISSPQByID', param, function (res) {
                that.$refs.SetBtn.SetOneBtnEnable('del',true);
                if (res.Success == 1) {
                    that.getView();
                    that.confirmAdd();
                    that.$message.success(that.$t('getapi[659]'));//'删除成功'
                }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1;
                that.IsEditPrice = true;
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/ISS/PQ/ISSPQInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.dataDetail.OldUnitPrice = that.dataDetail.Unit_Price;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority()
                    }
                    loadingInstance.close()
                });
            },

            handleSelectionChange1(val){
                let that = this;
                that.selectData1 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData1.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange2(val){
                let that = this;
                that.selectData2 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData2.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange3(val){
                let that = this;
                that.selectData3 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData3.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange4(val){
                let that = this;
                that.selectData4 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData4.push(val[i]);
                }
                that.btnauthority()
            },
            // 生产业务图
            getPro(){
                let that = this
                let data = {}
                if(that.SelectIndex == 0){
                    data = that.selectData[0]
                } else if (that.SelectIndex == 1){
                    data = that.selectData1[0]
                } else if (that.SelectIndex == 2){
                    data = that.selectData2[0]
                } else if (that.SelectIndex == 4){
                    data = that.selectData4[0]
                }
                that.$store.commit('setSharedParams', data);
                let item = {
                    label: '生产关系图',
                    name: 'prorelation',
                    path: '/prorelation/sr',
                    url: '/prorelation/sr',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/prorelation/sr'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            //批量删除
            batchDel(){
                let that = this
                let arr = []
                if(that.selectData1.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData1.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData1[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRDelLine', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            //批量下达
            batchRelease(){
                let that = this
                let arr = []
                if(that.selectData1.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData1.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData1[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRRelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            //撤销下达
            releaseToCreate(){
                let that = this
                let parm = {
                    sr_code: that.selectData2[0].SR_code
                }
                that.$http.urlpost('/Pro/SR/SRReleaseToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            //取消
            batchCancel(){
                let that = this
                let arr = []
                if(that.selectData2.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData2.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData2[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRBatchCancel', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            //生成
            cancelToCreate(){
                let that = this
                let parm = {
                    sr_code: that.selectData4[0].SR_code,
                }
                that.$http.urlpost('/Pro/SR/SRCancelToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            expStatus(val){
              if(val == 0){
                  return '生成'
              } else if(val == 1){
                  return '下达'
              } else if(val == 2){
                  return '已下单'
              } else if(val == 3){
                  return '取消'
              } else {
                  return ''
              }
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            sr_code : that.dataDetail.Head.sr_code,
                            sr_status:that.dataDetail.Head.sr_status
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pro/SR/DelSr', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //获取物料
            selectpart() {
                let that = this;
                if(!that.$limits.fnIsEmpty(that.dataDetail.num))return;
                that.$refs.part.clearInput(true);
            },
            //委外获取物料弹窗
            selectpartt(){
                let that = this;
                //if(!that.$limits.fnIsEmpty(that.dataDetail.num))return;
                if (that.$limits.fnIsEmpty(that.dataDetail.Part_ID)) {
                    that.$message.warning(this.$t('getapi[8793]'));//'请先选择物料'
                    return;
                }
                let param =  {
                    PUBPart_ID: that.dataDetail.Part_ID
                }
                that.$refs.partt.clearInput(true,param);
            },

            getpart(data){
                let that = this
                console.log(data)
                that.dataDetail.Part_Code = data.part_code;
                that.dataDetail.Part_Name = data.part_name;
                that.dataDetail.InvUnit = data.part_master_unit;
                that.dataDetail.Part_ID = data.exclusively_id;
                //that.getSignList(data.exclusively_id)
            },
            getSignList(id){
              let that = this
              let parm = {
                  Id: id
              }
                that.$http.urlpost('/Pro/SR/GetSrSignsByPartId', parm, function (res) {
                    if (res.Success == 1) {
                        that.SignList = res.DataContent.DataList
                    }
                });
            },
            selectitem() {
                let that = this;
                that.$refs.item.clearInput(true);
            },
            getitem(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.item_code = data.item_code
            },
            getBatchNetPrice(data) {
                let that = this;
                that.dataDetail.BatchLists[data.$index].price = (parseFloat(that.dataDetail.BatchLists[data.$index].price));
                that.dataDetail.BatchLists[data.$index].net_price = parseFloat((that.dataDetail.BatchLists[data.$index].price / (1 + that.dataDetail.Tax_Rate / 100)).toFixed(6));
            },
            getBatchNetUnitPrice(data) {
                let that = this;
                that.dataDetail.BatchLists[data.$index].net_price = (parseFloat(that.dataDetail.BatchLists[data.$index].net_price));
                that.dataDetail.BatchLists[data.$index].price = parseFloat((that.dataDetail.BatchLists[data.$index].net_price * (1 + that.dataDetail.Tax_Rate / 100)).toFixed(6));
            },
            addBatchPrice() {
                let that = this;
                that.dataDetail.BatchLists = [
                    ...that.dataDetail.BatchLists,
                    {
                        Exclusively_ID: 0,
                        vender_code: that.dataDetail.Vender_Code == ''?'':that.dataDetail.Vender_Code,
                        p_part_ID: 0,
                        batch_floor_limit: '',
                        price: '',
                        net_price: '',
                        routing_sequence_no: that.dataDetail.RoutingSequenceNo == ''?'':that.dataDetail.RoutingSequenceNo,
                        Relation_IID: that.dataDetail.num == ''?'':that.dataDetail.num
                    }
                ];
            },
            // 多选
            handleSelectionChangePrice(val) {
                let that = this;
                that.ids = ''
                that.selectDataPrice = []
                for (let i = 0; i < val.length; i++) {
                    that.ids = that.ids + val[i].Exclusively_ID + ','
                    that.selectDataPrice.push(val[i])
                }
                that.ids = that.ids.substring(0, that.ids.length - 1)
                that.btnauthority()
            },
            batchDelPrice(){
                let that = this
                let parm = {
                    exclusively_id: that.dataDetail.num,
                    ids: that.ids
                }
                that.$http.urlpost('/ISS/PQAudit/DeleteBatchPrice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if(!that.$limits.fnIsEmpty(that.dataDetail.num)){
                            that.getDetail(that.dataDetail.num);//刷右边
                        }
                    }
                });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 129,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                delete datacopy.Lists[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	overflow-x: auto;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
			margin-left: 10px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 0px;
		}
	}
}
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
